// @flow
import React from 'react';
import * as css from './CardContainer.module.css';

type PropType = {
  children?: React.Node,
  isComviq?: boolean,
};

const CardContainer = ({ children, isComviq = false }: PropType) => {
  return isComviq ? (
    <div className={css.posRel}>
      <div className={css.posAbs}>{children}</div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default React.memo(CardContainer);
